// Read-only "view as": staff see a company's or partner's pages as its admin would. The server refuses every write
// while viewing as; the top bar says so in red with an Exit button. The bar also shows in the member and partner
// app, so its look stays as it was; only the staff button uses the staff app's kit.
import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { api, useMe, useRefreshMe, useSelectCompany, useSelectPartner } from '../../lib'
import { errorText } from './kit'
import { setSide } from '../../app/side'

export function ViewAsButton({ kind, id }: { kind: 'company' | 'partner'; id: string }) {
  const refresh = useRefreshMe()
  const qc = useQueryClient()
  const selectCompany = useSelectCompany()
  const selectPartner = useSelectPartner()
  const navigate = useNavigate()
  const [error, setError] = useState<unknown>(null)
  const start = async () => {
    try {
      await api('POST', '/api/staff/view-as', { kind, id })
      if (kind === 'company') selectCompany(id)
      else selectPartner(id)
      qc.clear()
      await refresh()
      setSide(kind)
      navigate(kind === 'company' ? '/' : '/partner')
    } catch (e) {
      setError(e)
    }
  }
  return (
    <>
      <button type="button" className="st-btn" onClick={start} data-testid="staff-view-as">View as {kind === 'company' ? 'this company' : 'this partner'}</button>
      {error !== null && <span className="st-bad" role="alert">{errorText(error)}</span>}
    </>
  )
}

/** The red top-bar strip shown while viewing as. */
export function ViewAsBar() {
  const { me } = useMe()
  const refresh = useRefreshMe()
  const qc = useQueryClient()
  const navigate = useNavigate()
  const v = me?.view_as
  if (!v) return null
  const exit = async () => {
    await api('POST', '/api/staff/view-as/end', {})
    qc.clear()
    await refresh()
    setSide('staff')
    navigate(`/staff/${v.kind}/${v.id}`)
  }
  return (
    <div className="view-as-bar" role="status" data-testid="staff-view-as-bar">
      <span>Viewing as <strong>{v.name}</strong>. Read-only: nothing you press here changes anything.</span>
      <button type="button" onClick={exit} data-testid="staff-view-as-exit">Exit</button>
    </div>
  )
}
